import { get, trimEnd } from "lodash";

import * as routes from "routes";

const royaltyPayorParam = ":royaltyPayorName";
const assetIdParam = ":assetId";

export const connectGetValuationRoyaltyPayorAccount = (
  royaltyPayorId = royaltyPayorParam,
) => `${routes.sellerAddRoyaltyAccount()}/connect/${royaltyPayorId}`;

export const connectGetValuationRoyaltyPayorAccountSuccess = (
  royaltyPayorId = royaltyPayorParam,
) => `${routes.sellerAddRoyaltyAccount()}/connect/${royaltyPayorId}/success`;

export const connectGetCredentialsRoyaltyPayorAccount = (
  royaltyPayorId = royaltyPayorParam,
) => `${routes.sellerAddRoyaltyAccount()}/credentials/${royaltyPayorId}`;

export const connectGetCredentialsRoyaltyPayorAccountDetails = (
  royaltyPayorId = royaltyPayorParam,
  assetId = assetIdParam,
) =>
  `${routes.sellerAddRoyaltyAccount()}/credentials/${royaltyPayorId}/${assetId}/details`;

export const connectGetCredentialsRoyaltyPayorAccountSuccess = (
  royaltyPayorId = royaltyPayorParam,
) =>
  `${routes.sellerAddRoyaltyAccount()}/credentials/${royaltyPayorId}/success`;

export const otherSourceSubmission = () =>
  `${routes.sellerAddRoyaltyAccount()}/other-source`;

export const otherSourceSubmissionSuccess = () =>
  `${otherSourceSubmission()}/success`;

interface BackRoute {
  label: string;
  route: string;
}
// NOTE: this follows our usual convention of not having a trailing `/` on the path.
// Use the helper below to trim a trailing `/` and get the reverse route flexibly.
export const makeBackRouteMap = (
  royaltyPayorId: string,
  assetId: string,
): Record<string, BackRoute> => ({
  [routes.sellerAddRoyaltyAccount()]: {
    label: "Exit to Dashboard",
    route: routes.sellerDashboard(),
  },
  [connectGetValuationRoyaltyPayorAccount(royaltyPayorId)]: {
    label: "Back",
    route: routes.sellerAddRoyaltyAccount(),
  },
  [connectGetValuationRoyaltyPayorAccountSuccess(royaltyPayorId)]: {
    label: "Exit to Dashboard",
    route: routes.sellerDashboard(),
  },
  [connectGetCredentialsRoyaltyPayorAccount(royaltyPayorId)]: {
    label: "Back",
    route: routes.sellerAddRoyaltyAccount(),
  },
  [connectGetCredentialsRoyaltyPayorAccountDetails(royaltyPayorId, assetId)]: {
    label: "Back",
    route: connectGetCredentialsRoyaltyPayorAccount(royaltyPayorId),
  },
  [connectGetCredentialsRoyaltyPayorAccountSuccess(royaltyPayorId)]: {
    label: "Exit to Dashboard",
    route: routes.sellerDashboard(),
  },
  [otherSourceSubmission()]: {
    label: "Back",
    route: routes.sellerAddRoyaltyAccount(),
  },
  [otherSourceSubmissionSuccess()]: {
    label: "Exit to Dashboard",
    route: routes.sellerDashboard(),
  },
});

export const getBackRoute = (
  url: string,
  backRouteMap: Record<string, BackRoute>,
): BackRoute => {
  const urlTrimmed = trimEnd(url, "/");
  return get(backRouteMap, urlTrimmed, {
    label: "Exit",
    route: routes.sellerDashboard(),
  });
};
